const datetime = (date) => {
    if (typeof date === 'string') {
        const d = new Date(date)
        return `${d.toLocaleString()}`
    }
    return date
}

const shortDateTime = (date) => {
    if (typeof date === 'string') {
        const d = new Date(date)
        return `${d.toLocaleTimeString([], {year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit'})}`
    }
    return date
}

const fixDayOffByOne = (date) => date.replace(/-/g, '/').replace(/T.+/, '');

const date = (date) => {
    if (typeof date === 'string') {
        date = fixDayOffByOne(date);
        return new Date(date).toLocaleDateString()
    } else if (date instanceof Date) {
        return date.toLocaleDateString()
    }
    return date
}

const scoreboardDate = (date) => {
    const options = {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'}
    options.timeZone = 'UTC'
    options.timeZoneName = 'short'
    return date.toLocaleString('en-US', options)
}

const time = (date) => {
    if (typeof date === 'string') {
        return new Date(date).toLocaleTimeString()
    } else if (date instanceof Date) {
        return date.toLocaleTimeString()
    }
    return date
}

const readableDate = (date) => {
    if (!date) return ''
    const split = date.split('-')
    const newDate = split[1] + '/' + split[2] + '/' + split[0]
    return newDate
}

const monthDay = (date) => {
    if (!date) return ''
    const split = date.split('-')
    const newDate = split[1] + '/' + split[2]
    return newDate
}

const monthDayLong = (date) => {
    if (!date) return
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    return `${months[date.getMonth()]} ${date.getDate()}`
}

const dateRange = (item) => {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    const startSplit = item.startDate.split('/')
    const endSplit = item.endDate.split('/')

    let date
    if (startSplit[0] === endSplit[0]) {
        let index = parseInt(startSplit[0]) - 1
        let month = months[index]
        let dayOne = parseInt(startSplit[1]).toString()
        let dayTwo = parseInt(endSplit[1]).toString()
        date = `${month} ${dayOne} - ${dayTwo}`
    } else {
        let startMonthIndex = parseInt(startSplit[0]) - 1
        let startDate = months[startMonthIndex]
        let dayOne = parseInt(startSplit[1]).toString()
        let endMonthIndex = parseInt(endSplit[0]) - 1
        let endDate = months[endMonthIndex]
        let dayTwo = parseInt(endSplit[1]).toString()
        date = `${startDate} ${dayOne} - ${endDate} ${dayTwo}`
    }
    return date
}

export default {
    datetime,
    shortDateTime,
    date,
    time,
    readableDate,
    scoreboardDate,
    monthDay,
    monthDayLong,
    dateRange,
    fixDayOffByOne,
}
